import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, App, ModalController, LoadingController } from 'ionic-angular';
import { IonicStorageModule, Storage } from '@ionic/storage';

import {
  UserService ,
  EntityService,
  CalculationService,
  HttpService,
  RowActionService,
  AccountingService,
  UserManagementService,
  HistoryService,
  provideEntityService,
  provideUserService,
  provideCalculationService,
  provideHttpService,
  provideRowActionService,
  provideUserManagementService,
  provideAccountingService ,
  provideHistoryService
} from './../services/index';

import { MyApp } from './app.component';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,    
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    { provide: HttpService, useFactory: provideHttpService, deps: [Http, Storage, App] } ,
    { provide: UserService, useFactory: provideUserService, deps: [HttpService, Storage] } ,
    { provide: EntityService, useFactory: provideEntityService, deps: [HttpService, Storage] } ,
    { provide: CalculationService, useFactory: provideCalculationService, deps: [HttpService] } ,
    { provide: RowActionService, useFactory: provideRowActionService, deps: [CalculationService, ModalController, LoadingController] } ,
    { provide: UserManagementService, useFactory: provideUserManagementService, deps: [HttpService]} ,
    { provide: AccountingService, useFactory: provideAccountingService, deps: [HttpService]} ,
    { provide: HistoryService, useFactory: provideHistoryService, deps: [HttpService] } ,
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts